import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { RemovedItemsDialogPageRoutingModule } from './removed-items-dialog-routing.module';

import { RemovedItemsDialogPage } from './removed-items-dialog.page';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		RemovedItemsDialogPageRoutingModule,
		TranslateModule
	],
	declarations: [RemovedItemsDialogPage]
})
export class RemovedItemsDialogPageModule { }

